import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router'
import { FormattedMessage } from 'react-intl'
import { register } from 'src/store/actions/user'
import MarkdownMessage from '@gluedigital/markdown-message'
import Loading from 'src/components/Loading/Loading'
import { RegisterUser } from 'src/store/actions/user'

import './Register.sass'

const Register = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [status, setStatus] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (status === 'loading') return
    const user: RegisterUser = {
      firstName: e.target.firstName.value,
      lastName: e.target.lastName.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      client: e.target.client.value
    }
    setStatus('loading')
    dispatch(register(user))
      .then(() =>
        navigate({
          pathname: '/verification'
        })
      )
      .catch(() => setStatus('error'))
  }
  const registerForm = (
    <form onSubmit={handleSubmit} className={status}>
      <div className="user-wrapper">
        <label>
          <span className="icon icon-user" />
          <FormattedMessage id="placeholder.name">
            {(text: string) => (
              <input
                type="text"
                name="firstName"
                placeholder={text}
                autoComplete="given-name"
                required
              />
            )}
          </FormattedMessage>
        </label>
        <label>
          <FormattedMessage id="placeholder.surname">
            {(text: string) => (
              <input
                type="text"
                name="lastName"
                placeholder={text}
                autoComplete="family-name"
                required
              />
            )}
          </FormattedMessage>
        </label>
      </div>
      <label>
        <span className="icon icon-building" />
        <FormattedMessage id="placeholder.client">
          {(text: string) => (
            <input
              type="text"
              name="client"
              placeholder={text}
              autoComplete="organization"
            />
          )}
        </FormattedMessage>
      </label>
      <label>
        <span className="icon icon-mail" />
        <FormattedMessage id="placeholder.email">
          {(text: string) => (
            <input
              type="email"
              name="email"
              placeholder={text}
              autoComplete="email"
              required
            />
          )}
        </FormattedMessage>
      </label>
      <label>
        <span className="prefix">+34</span>
        <FormattedMessage id="placeholder.tel">
          {(text: string) => (
            <input
              type="tel"
              name="phone"
              placeholder={text}
              autoComplete="current-phone"
              minLength={9}
              maxLength={9}
              pattern="[0-9]{9}"
              title="Teléfono (nueve dígitos numéricos)"
              required
            />
          )}
        </FormattedMessage>
      </label>
      <label className="terms">
        <input type="checkbox" name="terms" required />
        <FormattedMessage
          id="register.terms"
          values={{
            link: (
              <Link to="/legal">
                <FormattedMessage id="register.terms-link" />
              </Link>
            )
          }}
        />
      </label>
      <p className={`error-message ${status}`}>
        {status === 'error' && (
          <span>
            <FormattedMessage id="register.error" />
          </span>
        )}
      </p>
      <button className="filled" type="submit">
        <FormattedMessage id="register" />
      </button>
    </form>
  )

  return (
    <div id="register" className="page split">
      <header className="item left" id="login-header">
        <div className="logo" />
      </header>
      <section className="item right" id="register-content">
        <div className="wrapper">
          <img src="images/logo.png" alt="logo" />
          <div className="register-form">
            <h2>
              <FormattedMessage id="register.title" />
            </h2>
            {status !== 'loading' ? registerForm : <Loading />}
          </div>
          <h4>
            <Link className="login-link" to="/">
              <MarkdownMessage id="register.already" />
            </Link>
          </h4>
        </div>
      </section>
    </div>
  )
}

export default Register
